import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from '../Tabs/Tabs';
// import CancellationRulePresenterTabs from "./CancellationRulePresenterTabs";
import CancellationRulePresenterTabContent from "./CancellationRulePresenterTabContent";

class CancellationRulePresenter extends React.Component {

  constructor(props) {
    super(props)

    var billing_policies
    this.props.cancellation_rule.billing_policies && this.props.cancellation_rule.billing_policies.length > 0
      ? billing_policies = this.props.cancellation_rule.billing_policies.map(bp => bp.name)
      : billing_policies = []

    this.state = {
      active_tab: this.props.active_tab || 'general',
      tabs: true,
      name: this.props.cancellation_rule.name || '',
      code: this.props.cancellation_rule.code || '',
      amount: this.props.cancellation_rule.amount || '',
      days_charge: this.props.cancellation_rule.days_charge || '',
      custom_rule: this.props.cancellation_rule.custom_rule || '',
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
      percentage: this.props.cancellation_rule.percentage || '',
      time_value: this.props.cancellation_rule.time_value || '',
      taxes: this.props.cancellation_rule.taxes || [],
      fees: this.props.cancellation_rule.fees || [],
      billing_policies: this.props.cancellation_rule.billing_policies || [],

      loading: false,
    }

    if (this.props.revert == true) {
      this.buttons = [
        {
          name: I18n.t('cancel'),
          html_attributes: [
              'data-dismiss="modal"'
          ]
        },
        {
          name: I18n.t('revert'),
          button_classes: ['primary'],
          onClick: function (e) {
              self.onChangeRevertVersion()
              return false;
          },
        },
      ];
    } else {
      this.buttons = [
        {
          name: I18n.t('ok'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        }
      ]
    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
  }

  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          e.stopPropagation()
          e.preventDefault()

          self.onSave()
        }
      }
    ]

    return (
        <div className="cancellation-rule-builder" ref="root">
          <Tabs tabs={this.tabs()} />
          <div className="panel panel-form">
            {/* <CancellationRulePresenterTabs {...this.state} onChangeActiveTab={this.onChangeActiveTab} /> */}
            <CancellationRulePresenterTabContent {...this.state}
              all_lodging_taxes={this.props.all_lodging_taxes}
              dateFormat={this.props.date_format} />
          </div>
          <ModalButtons loading={this.state.loading} buttons={this.buttons} />
          <LoadingSpinner show={this.state.loading} />
        </div>
    );
  };

  tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('billing_policies'),
          targetName: 'billing_policies',
          classes: this.state.active_tab === 'billing_policies' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        // {
        //   tabName: I18n.t('taxes'),
        //   targetName: 'taxes',
        //   classes: this.state.active_tab === 'taxes' ? 'active' : null,
        //   changeHandler: this.onChangeActiveTab,
        // },
      ]
    );
  };

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab})
  }

  onChangeRevertVersion() {
    var self = this
    $.ajax({
      type: 'POST',
      url: `/admin/cancellation_rules/${this.props.id}/version/${this.props.version.id}/revert`,
    }).done((data) => {
      window.parent.$(window.parent).trigger('cancellationRuleSaved');
      this.setState({loading: false});
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('record_reverted_successfully'));
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    });
  };

};

export default CancellationRulePresenter
